module.exports = __webpack_public_path__ + "static/img/bg_video_default.d18a85f8.jpg";